import 'bootstrap/dist/css/bootstrap.min.css';
import { Routes, Route, BrowserRouter } from "react-router-dom";
import './App.css';
import Login from './Pages/Login';
import LandingPage from './Pages/LandingPage';
import Register from './Pages/Register';
import Dashboard from './Pages/Dashboard';
import Vehicles from './Pages/Vehicles';
import Drivers from './Pages/Drivers';
import Clients from './Pages/Clients';
import Orders from './Pages/Orders';
import Invoices from './Pages/Invoices';
import Feedback from './Pages/Feedback';
import Trips from './Pages/Trips';
import OrderDetails from './Pages/OrderDetails';
import DriverTripsPage from './Pages/DriverTripsPage';
import TrackDriverPage from './Pages/TrackDriverPage';
import ClientOrdersPage from './Pages/ClientOrdersPage';
import TrackOrder from './Pages/TrackOrder';
import PricesCalculator from './Pages/PricesCalculator';
import InvoicePage from './Pages/InvoicePage';
import RecordPayment from './Pages/RecordPayment';
import Privacy from './Pages/Privacy';
import DeleteAccount from './Pages/DeleteAccount';
import ManualInvoices from './Pages/ManualInvoices';
import CustomerPortal from './Pages/CustomerPortal';
import RoleRoute from './Components/RoleRoute';

function App() {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/my-orders"
            element={
              <RoleRoute allowedRoles={["client"]}>
                <CustomerPortal />
              </RoleRoute>
            }
          />

          <Route
            path="/dashboard"
            element={
              <RoleRoute allowedRoles={["admin"]}>
                <Dashboard />
              </RoleRoute>
            }
          />
          <Route
            path="/vehicles"
            element={
              <RoleRoute allowedRoles={["admin"]}>
                <Vehicles />
              </RoleRoute>
            }
          />
          <Route
            path="/drivers"
            element={
              <RoleRoute allowedRoles={["admin"]}>
                <Drivers />
              </RoleRoute>
            }
          />
          <Route
            path="/clients"
            element={
              <RoleRoute allowedRoles={["admin"]}>
                <Clients />
              </RoleRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <RoleRoute allowedRoles={["admin"]}>
                <Orders />
              </RoleRoute>
            }
          />
          <Route
            path="/invoices"
            element={
              <RoleRoute allowedRoles={["admin"]}>
                <Invoices />
              </RoleRoute>
            }
          />
          <Route
            path="/feedback"
            element={
              <RoleRoute allowedRoles={["admin"]}>
                <Feedback />
              </RoleRoute>
            }
          />
          <Route
            path="/trips"
            element={
              <RoleRoute allowedRoles={["admin"]}>
                <Trips />
              </RoleRoute>
            }
          />
          <Route
            path="/orders/:id"
            element={
              <RoleRoute allowedRoles={["admin"]}>
                <OrderDetails />
              </RoleRoute>
            }
          />
          <Route
            path="/driver-trips/:uid"
            element={
              <RoleRoute allowedRoles={["admin"]}>
                <DriverTripsPage />
              </RoleRoute>
            }
          />
          <Route
            path="/track-driver/:uid"
            element={
              <RoleRoute allowedRoles={["admin"]}>
                <TrackDriverPage />
              </RoleRoute>
            }
          />
          <Route
            path="/client-orders/:clientId"
            element={
              <RoleRoute allowedRoles={["admin"]}>
                <ClientOrdersPage />
              </RoleRoute>
            }
          />
          <Route path="/track-order/:orderId" element={<TrackOrder />} />
          <Route
            path="/price-settings"
            element={
              <RoleRoute allowedRoles={["admin"]}>
                <PricesCalculator />
              </RoleRoute>
            }
          />
          <Route
            path="/invoice/:clientId"
            element={
              <RoleRoute allowedRoles={["admin"]}>
                <InvoicePage />
              </RoleRoute>
            }
          />
          <Route
            path="/record-payments"
            element={
              <RoleRoute allowedRoles={["admin"]}>
                <RecordPayment />
              </RoleRoute>
            }
          />

          <Route path="/privacy" element={<Privacy />} />
          <Route path="/delete-account" element={<DeleteAccount />} />

          <Route
            path="/manual-invoices"
            element={
              <RoleRoute allowedRoles={["admin"]}>
                <ManualInvoices />
              </RoleRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
